import Header from './Header';
class AlertBar {
    constructor({ item, module, updateH }) {
        this.item = item;
        this.module = document.querySelector(module);
    }

    checkState() {
        if (!sessionStorage.getItem(this.item)) {
            this.module.classList.add('show-item');
        }
    }

    setStorage() {
        sessionStorage.setItem(this.item, true);
        this.hideItem();
    }

    hideItem() {
        jQuery(this.module).slideUp();
        this.module.classList.remove('show-item');
        Header.setHeaderHeight();
    }

    init() {
        if (this.module) {
            this.checkState();
            const close = this.module.querySelector('[data-close-item]');
            const exit = this.module.querySelector('[data-exit-item]');
            close.addEventListener('click', () => {
                this.setStorage();
            });

            if (exit) {
                exit.addEventListener('click', () => {
                    this.hideItem();
                });
            }
        }
    }
}

const alertBarTop = {
    item: 'ohh-alert-top',
    module: '.main-header__alert',
}

const alertBarBottom = {
    item: 'ohh-alert-botom',
    module: '.cookie-bar',
}

const AlertTop = new AlertBar(alertBarTop);
const AlertBottom = new AlertBar(alertBarBottom);

export { AlertTop, AlertBottom };
